import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import * as authActions from "../auth/actions";
import * as actions from "./actions";
import { Record, Map } from "immutable";

import Forms from "./forms";
import CurrentUser from "./currentUser";
import Auth from "./auth";
import Table from "./table";

import cookie from "cookie-dough";
import { setAuthCookie, clearAuthCookie } from "../lib/auth";

const feature = "users";

const InitialState = Record({
  forms: new Forms(),
  table: new Table(),
  viewer: null,
  currentUser: new CurrentUser()
});

const initialState = new InitialState();

function revive({ viewer, currentUser }) {
  return initialState.merge({
    // Handle user authenticated on the server.
    viewer: viewer ? new Auth(viewer) : null,
    currentUser: currentUser ? new CurrentUser(currentUser) : null
  });
}

export default function usersReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  switch (action.type) {
    case authActions.LOGIN_SUCCESS: {
      const { access_token, refresh_token, expires_in } = action.payload;
      let auth = {
        accessToken: access_token,
        refreshToken: refresh_token,
        expiresInDate: new Date().getTime() / 1000 + expires_in
      };

      setAuthCookie(cookie, auth);

      return state.setIn(["viewer"], new Auth(auth));
    }

    case authActions.REFRESH_TOKEN_SUCCESS: {
      const { access_token, refresh_token, expires_in, error } = action.payload;
      let auth = {
        accessToken: access_token,
        refreshToken: refresh_token,
        expiresInDate: new Date().getTime() / 1000 + expires_in
      };

      if (!error) {
        setAuthCookie(cookie, auth);
        return state.setIn(["viewer"], new Auth(auth));
      }
    }

    case actions.POST_USERS_START: {
      return disableForm(state, "createUser");
    }
    case actions.POST_USERS_SUCCESS: {
      state = clearForm(state, "createUser", Forms);
      return enableForm(state, "createUser");
    }
    case actions.POST_USERS_ERROR: {
      state = enableForm(state, "createUser");
      return setFormErrors(state, "createUser", action.payload.errors);
    }

    case actions.GET_USERS_START: {
      return state.setIn(["table", "loading"], true);
    }
    case actions.GET_USERS_SUCCESS: {
      return state
        .setIn(["table", "data"], action.payload)
        .setIn(["table", "loading"], false);
    }
    case actions.GET_USERS_ERROR: {
      return state.setIn(["table", "loading"], false);
    }

    case actions.GET_CURRENT_USER_SUCCESS: {
      state = state.setIn(["forms", "twoFactorAuth", "dirty"], true);
      return state.set("currentUser", new CurrentUser(action.payload));
    }

    case actions.FORGOT_START: {
      return disableForm(state, "forgot");
    }
    case actions.FORGOT_SUCCESS: {
      return enableForm(state, "forgot").setIn(
        ["forms", "forgot", "sent"],
        true
      );
    }
    case actions.FORGOT_ERROR: {
      state = enableForm(state, "forgot");
      return setFormErrors(state, "forgot", action.payload.errors);
    }

    case actions.SET_PASSWORD_START: {
      return disableForm(state, "setPassword");
    }
    case actions.SET_PASSWORD_SUCCESS: {
      return enableForm(state, "setPassword").setIn(
        ["forms", "setPassword", "sent"],
        true
      );
    }
    case actions.SET_PASSWORD_ERROR: {
      state = enableForm(state, "setPassword");
      return setFormErrors(state, "setPassword", action.payload.errors);
    }

    case actions.CHANGE_PASSWORD_START: {
      return disableForm(state, "changePassword");
    }
    case actions.CHANGE_PASSWORD_SUCCESS: {
      state = clearForm(state, "changePassword", Forms);
      return enableForm(state, "changePassword");
    }
    case actions.CHANGE_PASSWORD_ERROR: {
      state = enableForm(state, "changePassword");
      return setFormErrors(state, "changePassword", action.payload.errors);
    }

    case actions.CHANGE_PROFILE_DATAS_START: {
      return disableForm(state, "changeProfileDatas");
    }
    case actions.CHANGE_PROFILE_DATAS_SUCCESS: {
      state = clearForm(state, "changeProfileDatas", Forms);
      return enableForm(state, "changeProfileDatas");
    }
    case actions.CHANGE_PROFILE_DATAS_ERROR: {
      state = enableForm(state, "changeProfileDatas");
      return setFormErrors(state, "changeProfileDatas", action.payload.errors);
    }

    case actions.ENABLE_TWO_FACTOR_AUTH_START:
      return disableForm(state, "twoFactorAuth");
    case actions.ENABLE_TWO_FACTOR_AUTH_SUCCESS:
      return clearForm(state, "twoFactorAuth", Forms);
    case actions.ENABLE_TWO_FACTOR_AUTH_ERROR: {
      state = enableForm(state, "twoFactorAuth");
      return setFormErrors(state, "twoFactorAuth", action.payload.errors);
    }

    case actions.ENABLE_TWO_FACTOR_AUTH_CHECKBOX_START:
      return disableForm(state, "twoFactorAuth").setIn(
        ["forms", "twoFactorAuth", "fields", "is2FA"],
        true
      );
    case actions.ENABLE_TWO_FACTOR_AUTH_CHECKBOX_SUCCESS:
      return enableForm(state, "twoFactorAuth").setIn(
        ["forms", "twoFactorAuth", "qrCode"],
        action.payload.qrCode
      );

    case actions.DISABLE_TWO_FACTOR_AUTH_CHECKBOX:
      return clearForm(state, "twoFactorAuth", Forms);

    case actions.SET_USER_TABLE_FIELD: {
      return state.setIn(["table", action.payload.name], action.payload.value);
    }

    case actions.SET_AUTH: {
      return state.setIn(["viewer"], action.payload.auth);
    }

    case actions.SET_USER_REMOVE_MODAL_OPEN: {
      return state.setIn(
        ["table", "isRemoveUserModalVisible"],
        action.payload.uidToRemove
      );
    }

    case actions.SET_USER_REMOVE_MODAL_CLOSE: {
      return state.setIn(["table", "isRemoveUserModalVisible"], false);
    }
  }

  return formsReducer(state, feature, action, Forms);
}



// WEBPACK FOOTER //
// ./src/common/users/reducer.js